import auth from './auth';
import budgetExpect from './budgetExpect';
import favoriteTest from './favoriteTest';
import common from './common';
import goodsCategory from './goodsCategory';
import shopSearch from './shopSearch';
import tracking from './tracking';
import webApp from './webapp';
import untactConsult from './untactConsult';
import hackle from './hackle';
import seqConsult from './seqConsult';

const rootReducer = {
  [auth.name]: auth.reducer,
  [budgetExpect.name]: budgetExpect.reducer,
  [favoriteTest.name]: favoriteTest.reducer,
  [goodsCategory.name]: goodsCategory.reducer,
  [shopSearch.name]: shopSearch.reducer,
  [webApp.name]: webApp.reducer,
  [common.name]: common.reducer,
  [tracking.name]: tracking.reducer,
  [untactConsult.name]: untactConsult.reducer,
  [hackle.name]: hackle.reducer,
  [seqConsult.name]: seqConsult.reducer,
};

export default rootReducer;
